import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'

import Button from '@/components/common/Button/Button'

import { useDriveStore } from '@/store/useDriveStore'

import BottomSheet from './BottomSheet'
import GoogleDriveIcon from './GoogleDriveIcon'

export const DriveConnectSheet = () => {
  const { t } = useTranslation()

  const activeSheet = useDriveStore((state) => state.activeSheet)
  const isConnecting = useDriveStore((state) => state.isConnecting)
  const failed = useDriveStore((state) => state.failed)
  const connect = useDriveStore((state) => state.connect)
  const closeSheet = useDriveStore((state) => state.closeSheet)

  return (
    <BottomSheet isOpen={activeSheet === 'connect'} onClose={closeSheet}>
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center justify-center min-w-12 min-h-12 rounded-full bg-zinc-100">
          <GoogleDriveIcon className="h-6 w-6" />
        </div>
        <h3 className="text-lg font-semibold text-zinc-900">
          {t('expenses.drive.connectSheet.title')}
        </h3>
      </div>

      <p className="text-base text-zinc-700">
        {t('expenses.drive.connectSheet.purpose')}
      </p>
      <p className="text-sm text-zinc-500 mt-3">
        {t('expenses.drive.connectSheet.privacy')}
      </p>

      {failed && (
        <p className="text-sm text-amber-700 mt-4">
          {t('expenses.drive.connectSheet.error')}
        </p>
      )}

      <Button
        isLoading={isConnecting}
        onClick={connect}
        className="h-12 w-full mt-6"
      >
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
        >
          {t('expenses.drive.connectSheet.cta')}
        </motion.span>
      </Button>
    </BottomSheet>
  )
}

export default DriveConnectSheet
